import { Text } from './Typography';
import styled from 'styled-components';

import DiscordFooterIcon from '../../assets/svg/DiscordFooter';
import XLogo from '../../assets/png/X.png';
// import TwitterFooterIcon from '../../assets/svg/TwitterFooter';
// import MediumFooterIcon from '../../assets/svg/MediumFooter';
import { RESPONSIVE_BREAKPOINTS } from '../../data/constants/Breakpoints';
import { GREY_400 } from '../../data/constants/Colors';
import { TERMS_OF_SERVICE_URL } from '../../data/constants/Values';

const StyledFooter = styled.footer`
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  min-height: 60px;
  background-color: #0d0115;
  border-top: 1px solid #290340;
  padding-left: 20px;
  padding-right: 20px;
  z-index: 40;

  @media (max-width: ${RESPONSIVE_BREAKPOINTS.TABLET}px) {
    display: none;
  }
`;

const FooterLink = styled(Text)`
  &:hover {
    color: #EA3324;
  }
`;

const VerticalDivider = styled.div`
  width: 1px;
  height: 12px;
  margin-left: 16px;
  margin-right: 16px;
  background-color: #290340;
`;

export default function Footer() {
  return (
    <StyledFooter>
      <div className='flex flex-row items-center'>
        <FooterLink
          as='a'
          size='S'
          weight='medium'
          color='#FFFFFF'
          href={'https://www.stackingsalmon.com'}
          target='_blank'
          rel='noopener noreferrer'
        >
          Home
        </FooterLink>
        <VerticalDivider />
        <FooterLink
          as='a'
          size='S'
          weight='medium'
          color='#FFFFFF'
          href={'https://stacking-salmon-1.gitbook.io/stacking-salmon/'}
          target='_blank'
          rel='noopener noreferrer'
        >
          Docs
        </FooterLink>
        <VerticalDivider />
        <FooterLink
          as='a'
          size='S'
          weight='medium'
          color='#FFFFFF'
          href={TERMS_OF_SERVICE_URL}
          target='_blank'
          rel='noopener noreferrer'
        >
          Terms
        </FooterLink>
      </div>
      <div className='flex flex-row items-center gap-x-6'>
        <a href={'https://discord.gg/k39EDRfrtR'} target='_blank' rel='noopener noreferrer' title='Join our Discord'>
          <DiscordFooterIcon width={14} height={11} />
        </a>
        <a
          href={'https://twitter.com/stackingsalmon'}
          target='_blank'
          rel='noopener noreferrer'
          title='Follow us on Twitter'
        >
          <img src={XLogo} width="15" height="11" alt=' '/>
        </a>
      </div>
    </StyledFooter>
  );
}